// Copyright (C) 2021 Bystronic Laser AG

export enum AggregateEnum {
  Min = 'min',
  Avg = 'avg',
  Q95 = 'q95',
  Max = 'max',
}
